/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListRolesWithPermissionsResponseDto,
  RoleDetailResponseDto,
  SetRolePermissionsRequestDto,
} from '../models/index';
import {
    ListRolesWithPermissionsResponseDtoFromJSON,
    ListRolesWithPermissionsResponseDtoToJSON,
    RoleDetailResponseDtoFromJSON,
    RoleDetailResponseDtoToJSON,
    SetRolePermissionsRequestDtoFromJSON,
    SetRolePermissionsRequestDtoToJSON,
} from '../models/index';

export interface SystemRoleControllerFindSystemRoleByIdRequest {
    roleId: string;
}

export interface SystemRoleControllerSetSystemRolePermissionsRequest {
    roleId: string;
    setRolePermissionsRequestDto: SetRolePermissionsRequestDto;
}

/**
 * 
 */
export class SystemRolesApi extends runtime.BaseAPI {

    /**
     */
    async systemRoleControllerFindSystemRoleByIdRaw(requestParameters: SystemRoleControllerFindSystemRoleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleDetailResponseDto>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling systemRoleControllerFindSystemRoleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/system-roles/{roleId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleDetailResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemRoleControllerFindSystemRoleById(requestParameters: SystemRoleControllerFindSystemRoleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleDetailResponseDto> {
        const response = await this.systemRoleControllerFindSystemRoleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async systemRoleControllerListSystemRolesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListRolesWithPermissionsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/system-roles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListRolesWithPermissionsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemRoleControllerListSystemRoles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListRolesWithPermissionsResponseDto> {
        const response = await this.systemRoleControllerListSystemRolesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async systemRoleControllerSetSystemRolePermissionsRaw(requestParameters: SystemRoleControllerSetSystemRolePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleDetailResponseDto>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling systemRoleControllerSetSystemRolePermissions().'
            );
        }

        if (requestParameters['setRolePermissionsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'setRolePermissionsRequestDto',
                'Required parameter "setRolePermissionsRequestDto" was null or undefined when calling systemRoleControllerSetSystemRolePermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/system-roles/{roleId}/permissions`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetRolePermissionsRequestDtoToJSON(requestParameters['setRolePermissionsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleDetailResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async systemRoleControllerSetSystemRolePermissions(requestParameters: SystemRoleControllerSetSystemRolePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleDetailResponseDto> {
        const response = await this.systemRoleControllerSetSystemRolePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
